<template lang="pug">
  #ReservationEdit.container-width
    h5.text-center.pt-2 修改預約
    .p-3
      .mb-2
        ValidationObserver(
          ref="form"
          tag="form"
          @submit.stop.prevent="submitHandler"
        )
          b-form-group
            ValidationProvider(
              ref="inputValname",
              v-slot="{ errors }"
            )
              b-form-input.inputStyle(
                id="name",
                type="text",
                required,
                trim,
                :state="validState('name')",
                v-model="form.name",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請輸入姓名",
                disabled
              )
              b-form-invalid-feedback.text-center(
                id="input-name-live-feedback"
              )
                span {{ errors[0] }}

          b-form-group
            ValidationProvider(
              ref="inputValphone",
              v-slot="{ errors }"
            )
              b-form-input.inputStyle(
                id="phone",
                type="text",
                required,
                trim,
                :state="validState('mobile')",
                v-model="form.mobile",
                aria-describedby="input-live-help input-phone-live-feedback",
                placeholder="請輸入手機",
                disabled
              )
              b-form-invalid-feedback.text-center(
                id="input-phone-live-feedback"
              )
                span {{ errors[0] }}

          b-form-group
            ValidationProvider(
              ref="inputValstore",
              v-slot="{ errors }"
            )
              b-form-input.inputStyle(
                id="store",
                type="text",
                required,
                trim,
                :state="validState('store')",
                v-model="form.store",
                aria-describedby="input-live-help input-store-live-feedback",
                placeholder="請輸入櫃點",
                disabled
              )
              b-form-invalid-feedback.text-center(
                id="input-store-live-feedback"
              )
                span {{ errors[0] }}

          b-form-group.my-3.position-relative
            ValidationProvider(
              ref="inputValItem"
              v-slot="{ errors }"
            )
              b-form-select.select-round(
                id="service",
                required,
                v-model="form.service",
                :state="validState('service')",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請選擇預約服務"
                style='opacity: 0'
              )
                template(
                  v-slot:first
                )
                b-form-select-option(
                  v-for="(item,index) in reservationsTypeList",
                  :key="item.id",
                  :value="item.id"
                ) {{ item.name }}

              b-form-input.inputStyle.position-absolute(
                id="store",
                type="text",
                required,
                trim,
                :state="validState('service')",
                v-model="filterStore",
                aria-describedby="input-live-help input-store-live-feedback",
                placeholder="請輸入櫃點",
                disabled
                style='top: 0'
              )
              b-form-invalid-feedback.text-center(
                id="input-store-live-feedback"
              )
                span {{ errors[0] }}
              b-form-invalid-feedback.text-center(
                id="input-name-live-feedback"
              )
                span 此欄不可為空

          b-form-group
            ValidationProvider(
              ref="inputValDate"
            )
              b-form-datepicker.datepicker-round.text-center(
                id="date",
                type="date",
                required,
                trim,
                :state="validState('date')",
                v-model="form.date",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請選擇預約日期",
                :min="dateMinLimit"
              )
              b-form-invalid-feedback.text-center(
                id="input-name-live-feedback"
              )
                span 此欄不可為空

          b-form-group.my-3.position-relative
            ValidationProvider(
              ref="inputValItem"
              v-slot="{ errors }"
            )

              b-form-input.inputStyle.position-absolute(
                id="store",
                type="text",
                required,
                trim,
                :state="validState('timeId')",
                v-model="filterReservationTime",
                aria-describedby="input-live-help input-store-live-feedback",
                placeholder="請選擇預約時段",
                style='top: 0'
              )

              b-form-select.select-round(
                id="timeRange",
                required,
                v-model="form.timeId",
                :state="validState('timeId')",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請選擇預約時段"
                style='opacity: 0'
              )
                template(
                  v-slot:first
                )
                  b-form-select-option(
                    :value="null",
                    disabled
                  ) 請選擇預約時段
                b-form-select-option(
                  v-for="(item) in reservationTimeList",
                  :key="item.id",
                  :value="item"
                ) {{ item.start_time }} - {{ item.end_time }}
              b-form-invalid-feedback.text-center(
                id="input-name-live-feedback"
              )
                span 此欄不可為空

          b-form-group.my-3
            ValidationProvider(
              ref="inputValSaNote"
            )
              b-form-textarea(
                id="m_note",
                type="text",
                rows="3",
                v-model="form.m_note",
                placeholder="輸入備註"
              )
      .px-4
        .row
          .col-6
            button.button.btn-block.button_clickCustom.button_clickCustom-primary(
              type="button",
              @click="$router.push({ name: 'm-reservation-index' })"
            ) 取消
          .col-6
            button.button.btn-block.button_clickCustom.button_clickCustom-primary(
              type="button",
              @click="submitHandler()"
            ) 儲存修改
</template>

<script>
import { mapState } from 'vuex';
import { M_RESERVATION_INDEX } from '@/router/member/reservation';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';

const moment = require('moment');
const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

export default {
  name: 'ReservationEdit',
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    editInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDate = new Date(today);
    return {
      form: {
        name: null,
        service: null,
        date: null,
        timeId: null,
        memberNote: null,
        saNote: null
      },
      dateMinLimit: minDate,
      original_form: {
        name: null,
        service: null,
        date: null,
        timeId: null,
        memberNote: null,
        saNote: null
      } // 用來比對的
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        vm.$swal.showLoading();
      }
    });

    // 塞回資料
    vm.form.name = vm.editInfo.sa_chinese_last_name + vm.editInfo.sa_chinese_first_name;
    vm.form.service = vm.editInfo.reserve_type_id;
    vm.form.date = vm.editInfo.reserve_date;
    vm.form.store = vm.editInfo.store_name;
    vm.form.mobile = vm.editInfo.mobile;
    const reservationTimeListKey = _.findKey(vm.reservationTimeList, (item) => item.id === vm.editInfo.reservation_period_id);
    vm.form.timeId = vm.reservationTimeList[reservationTimeListKey];
    vm.form.m_note = vm.editInfo.m_note;

    vm.original_form.name = vm.editInfo.sa_chinese_last_name + vm.editInfo.sa_chinese_first_name;
    vm.original_form.service = vm.editInfo.reserve_type_id;
    vm.original_form.date = vm.editInfo.reserve_date;
    vm.original_form.store_name = vm.editInfo.store_name;
    vm.original_form.mobile = vm.editInfo.mobile;
    vm.original_form.timeId = vm.reservationTimeList[reservationTimeListKey];
    vm.original_form.m_note = vm.editInfo.m_note;

    // 取得預約服務選項
    vm.$store.dispatch('member_reservation/getReservationTypeListHandler')
      .then(() => {
        vm.$swal.close();
      });
  },
  methods: {
    nameWithTimeId({ start_time, end_time }) {
      return `${start_time}~${end_time}`;
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      // 其餘統一判斷
      if (vm.form[key] !== null) {
        return this.form[key] ? true : false;
      }
      return null;
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      if (_.isEqual(_.sortBy(vm.form), _.sortBy(vm.original_form))) {
        vm.$snotify.success(null, '修改成功');
        vm.$router.push({
          name: M_RESERVATION_INDEX
        });
      } else {
        const isValid = await this.$refs.form.validate();
        if (!isValid) {
          if (vm.form.name === null) {
            vm.form.name = '';
          }
          if (vm.form.service === null) {
            vm.form.service = '';
          }
          if (vm.form.date === null) {
            vm.form.date = '';
          }
          if (vm.form.timeId === null) {
            vm.form.timeId = '';
          }
          vm.$swal.fire({
            icon: 'error',
            title: '請填妥必填欄位或格式輸入錯誤'
          });
        } else {
          const key = _.findKey(vm.reservationTimeList, (val) => val.id === vm.form.timeId.id);
                const now = moment().format('hh:mm');
                const beginTime = moment(vm.reservationTimeList[key].start_time, 'hh:mma');
                const endTime = moment(now, 'hh:mma');
                const today = moment().format('YYYY-MM-DD');
                const reservationDate = moment(vm.form.date).format('YYYY-MM-DD');

          if (moment(reservationDate).isBefore(today)) {
            vm.$swal.fire({
              icon: 'error',
              title: '預約時間不可小於目前日期'
            });
          } else if (vm.form.date === moment().format('YYYY-MM-DD') && beginTime.isBefore(endTime)) {
            vm.$swal.fire({
              icon: 'error',
              title: '預約時間不可小於目前時間'
            });
          } else {
            vm.$swal.fire({
              title: '表單送出中，請稍候',
              allowOutsideClick: false,
              willOpen: () => {
                vm.$swal.showLoading();
              }
            });

            const sendData = {
              reservation_id: vm.editInfo.reservation_id,
              reservation_type_id: vm.form.service,
              date: vm.form.date,
              reservation_period_id: vm.form.timeId.id,
              m_note: vm.form.m_note
            };

          vm.$store.dispatch('member_reservation/updateReservationHandler', sendData)
            .then(() => {
              vm.$swal.fire({
                title: '修改預約',
                html: '<p class="mb-0">已成功送出預約修改</p><p class="mb-0">請靜待美容顧問確認時間！</p>',
                showCancelButton: false,
                confirmButtonText: '確定',
                customClass: {
                  confirmButton: 'btn btn-primary px-5'
                }
              })
              .then(() => {
                vm.$swal.close();
                vm.$snotify.success(null, '修改成功');
                vm.$router.push({
                  name: M_RESERVATION_INDEX
                });
              });
            });
          }
        }
      }
    },
  },
  computed: {
    ...mapState({
      reservationsTypeList: (state) => state.member_reservation.reservationsTypeList,
      reservationTimeList: (state) => state.member_reservation.reservationTimeList
    }),
    filterStore() {
      const vm = this;
      return _.filter(vm.reservationsTypeList, (val) => val.id === vm.form.service)[0].name;
    },
    filterReservationTime() {
      const vm = this;
      if (!vm.form.timeId) return null;
      const time = _.filter(vm.reservationTimeList, (val) => val.id === vm.form.timeId.id)[0];
      return `${time.start_time} - ${time.end_time}`;
    }
  }
};
</script>

<style>

</style>
